<template>
  <div class="page-wr">

    <div class="content">

      <div class="data-tip" style="margin-bottom: 26px;">
        <svg viewBox="0 0 16 16" width="17px" height="17px">
          <path fill="#4285f4" d="M8 15A7 7 0 108 1a7 7 0 000 14zM7.4 4h1.2v1.2H7.4V4zm.1 2.5h1V12h-1V6.5z"
                fill-opacity="0.9"></path>
        </svg>
        <span
            class="msg">尊敬的纳税人，请仔细核对应缴款信息后进行税费缴纳。若未缴款成功导致税（费）款被锁定，可通过“缴款凭证处理”解锁后重新缴纳。</span>

        <div class="grow"></div>

        <el-icon
            style="cursor: pointer;"
            size="19"
            color="#333333"
        >
          <Close/>
        </el-icon>
      </div>

      <el-card>
        <el-tabs v-model="activeName" class="demo-tabs">
          <el-tab-pane label="未缴税费" name="未缴税费">

            <el-table
                class="tax-table"
                ref="tableRef"
                :data="tableData"
                height="200"
            >

              <el-table-column type="selection" width="60"/>

              <el-table-column label="序号" type="index" align="center" width="60"/>

              <el-table-column label="税（费）种" prop="sz" align="center" width="150"/>

              <el-table-column label="税（品）目" prop="sm" align="center" width="100"/>

              <el-table-column label="税款所属期起" prop="skq" align="center" width="120"/>

              <el-table-column label="税款所属期止" prop="skz" align="center" width="120"/>

              <el-table-column label="申报日期" prop="sbDate" align="center" width="120"/>

              <el-table-column label="缴款期限" prop="sqqx" align="center" width="100"/>

              <el-table-column label="应缴税额" prop="yjTax" align="center" width="120"/>

              <el-table-column label="实缴税额" prop="sjTax" align="center" width="120"/>

              <el-table-column label="滞纳金" prop="cnj" align="center" width="80"/>
            </el-table>
          </el-tab-pane>

          <el-tab-pane label="已预约扣款信息" name="已预约扣款信息"></el-tab-pane>
          <el-tab-pane label="缴款凭证处理" name="缴款凭证处理"></el-tab-pane>
        </el-tabs>
      </el-card>

      <el-card style="margin-top: 30px;">

        <template #header>
          <div>
            <span>请选择支付方式</span>
          </div>
        </template>

        <div class="pay-wrap-wrap">
          <div v-for="(item,idx) in payWayList"
               :class="{'active': idx == payWayActIdx}"
               :key="idx" class="item"
               @click="payWayActIdx = idx"
          >

            <img
                class="active-icon"
                src="https://static.rhkj.com/renhe_fe/other/327.png"/>

            <el-icon class="my-icon" color="#FFFFFF">
              <component
                  :is="item.icon"
              />
            </el-icon>
            <h5>{{ item.name }}</h5>
          </div>
        </div>


        <div class="data-tip">
          <svg viewBox="0 0 16 16" width="17px" height="17px">
            <path fill="#4285f4" d="M8 15A7 7 0 108 1a7 7 0 000 14zM7.4 4h1.2v1.2H7.4V4zm.1 2.5h1V12h-1V6.5z"
                  fill-opacity="0.9"></path>
          </svg>
          <span class="msg">选择“三方协议缴税”，系统将自动从签订的三方协议账户中扣除税费</span>
        </div>

        <div class="opera-bottom">
          <div class="info" v-if="taxQuestionType == 1 || taxQuestionType == 3">
            合计<span>{{ pageShowInfo.summary }}</span>元 ({{ pageShowInfo.summaryChinese }})
          </div>
          <div class="info" v-else-if="taxQuestionType == 2 || taxQuestionType == 4 || taxQuestionType == 6">
            合计<span>{{ pageShowInfo.back }}</span>元 ({{ pageShowInfo.backChinese }})
          </div>

          <div class="grow"></div>

          <div>
            是否同时缴纳滞纳金
            <el-switch
                v-model="isSwitch"
            />
          </div>

          <el-button
              style="margin-left: 10px;"
              size="large">预约缴款
          </el-button>
          <el-button
              size="large"
              type="primary" @click="exePay">立即缴款
          </el-button>

        </div>

      </el-card>

      <tax-payment-dialog
          v-model:visible="payVis"
          :static-config="staticConfig"
          @onConfirm="emit('payFinish')"
      />
    </div>
  </div>
</template>

<script setup>
import Big from "big.js";
import {toCapitalChinese} from "@/utils/number";
import {Help, Money, Postcard, Cloudy, ChatRound,} from '@element-plus/icons-vue'
import TaxPaymentDialog from "@/views/examCenter/reportTax/page/taxPaymentDialog.vue";
import {reportTaxDateConfig} from "@/views/examCenter/reportTax/reportTaxStaticConfig.js";

const emit = defineEmits(['payFinish'])
const activeName = ref('未缴税费')

const props = defineProps({
  currentQa: { // 当前题目信息对象
    required: true,
    type: Object,
  },
})

const tableRef = ref()
const tableData = ref([])

// 题目json信息转js对象
const qaData = computed(() => {
  const taxDataAll = props.currentQa?.solution && JSON.parse(props.currentQa.solution) || null
  return taxDataAll == null ? JSON.parse(props.currentQa.answer) : taxDataAll
})

const taxQuestionType = computed(() => {
  switch (props.currentQa.sonQueType) {
    case '21':
      return 1
    case '26': // 企税--一般
    case '22': // 企税--小规模
      return 2
    case '23':
      return 3
    case '24': // 印花税--小规模
    case '25': // 印花税--一般
      return 4
    case '201': //汇算清缴-企业所得税年度申报
      return 201
    case '2201': // 企业税v2025版本
    case '2601':
      return 6
    default:
      throw new Error('不支持的类型')
  }
})

const {staticConfig} = reportTaxDateConfig(props.currentQa)

// 页面显示合计的金额
const pageShowInfo = computed(() => {
  let summary = '0.00'
  if (taxQuestionType.value == 3) {
    summary = parseFloatNum(
        new Big(qaData.value.tax31.data.v34x1.value)
            .plus(qaData.value.tax31.data.v39x1.value)
            .plus(qaData.value.tax31.data.v40x1.value)
            .plus(qaData.value.tax31.data.v41x1.value)
    )
  } else if (taxQuestionType.value == 1) {
    summary = parseFloatNum(
        new Big(qaData.value.tax11.data.v22x1.value)
            .plus(qaData.value.tax11.data.v23x1.value)
            .plus(qaData.value.tax11.data.v24x1.value)
            .plus(qaData.value.tax11.data.v25x1.value)
    )
  }

  let back = '0.00'
  if (taxQuestionType.value == 2) {
    back = parseFloatNum(qaData.value.tax21.data.v28x1.value)
  } else if (taxQuestionType.value == 6) {
      back = parseFloatNum(qaData.value.tax21.data.v50x2.value)
  }

  if (taxQuestionType.value == 4) { // 印花税
    const data = qaData.value.data;
    const num1 = parseFloatNum(data.reduce((a, b) => new Big(a).plus(b.amountPayable), 0));
    const num2 = parseFloatNum(new Big(num1).div(2).round(2).toNumber());
    back = parseFloatNum(new Big(num1).minus(num2)); // num3
  } else if (taxQuestionType.value == 201) {
    back = parseFloatNum(qaData.value.tax53.data.v45x1.value)
  }

  return {
    summary: summary, // 第1、3题取这个
    summaryChinese: toCapitalChinese(summary),
    back, // 第2题、201题
    backChinese: toCapitalChinese(back),
  }
})

const isSwitch = ref(true)

onMounted(() => {
  if (taxQuestionType.value == 1 || taxQuestionType.value == 3) {
    tableData.value = [
      {
        id: 1,
        sz: '增值税及附加税',
        sm: '',
        skq: staticConfig.taxStartTime,
        skz: staticConfig.taxEndTime,
        sbDate: staticConfig.fillFormDate,
        yjTax: pageShowInfo.value.summary,
        sjTax: pageShowInfo.value.summary,
      }
    ]
  } else if (taxQuestionType.value == 2 || taxQuestionType.value == 6) {
    tableData.value = [
      {
        id: 1,
        sz: '企业所得税',
        sm: '',
        skq: staticConfig.taxStartTime,
        skz: staticConfig.taxEndTime,
        sbDate: staticConfig.fillFormDate,
        yjTax: pageShowInfo.value.back,
        sjTax: pageShowInfo.value.back,
      }
    ]
  } else if (taxQuestionType.value == 4) {
    tableData.value = [
      {
        id: 1,
        sz: '印花税',
        sm: '',
        skq: staticConfig.taxStartTime,
        skz: staticConfig.taxEndTime,
        sbDate: staticConfig.fillFormDate,
        yjTax: pageShowInfo.value.back,
        sjTax: pageShowInfo.value.back,
      }
    ]
  } else if (taxQuestionType.value == 201) {
    tableData.value = [
      {
        id: 1,
        sz: '企业所得税',
        sm: '',
        skq: staticConfig.taxStartTime,
        skz: staticConfig.taxEndTime,
        sbDate: staticConfig.fillFormDate,
        yjTax: pageShowInfo.value.back,
        sjTax: pageShowInfo.value.back,
      }
    ]
  }

  nextTick(() => {
    tableRef.value.toggleRowSelection(tableData.value[0], true)
  })
})

function parseFloatNum(s, num = 2) {
  try {
    return new Big(s).toFixed(num);
  } catch (e) {
    console.log(e);
  }
}


const payWayActIdx = ref(0)

const payWayList = [
  {
    name: '三方协议缴款',
    icon: Help,
  },
  {
    name: '银联缴款',
    icon: Money,
  },
  {
    name: '银行端口（查询缴款）',
    icon: Postcard,
  },
  {
    name: '云闪付',
    icon: Cloudy,
  },
  {
    name: '微信、支付宝',
    icon: ChatRound,
  },
]

const payVis = ref(false)

function exePay() {
  tableRef.value.toggleRowSelection(tableData.value[0], true)
  payVis.value = true
}
</script>

<style scoped lang="scss">
.page-wr {
  background-color: #f7f8fa;
  height: calc(100% - 96px);
  overflow-y: auto;

  .content {
    width: 1200px;
    margin: auto;
    padding-top: 26px;

    .top-img {
      padding: 16px 0 26px 0;
      display: block;
    }

    :deep(.tax-table) {
      .el-table__header {
        th.el-table__cell {
          line-height: 40px;
          background-color: #f5f7fa;

          .cell {
            color: #000000;
            font-weight: 700;
          }
        }
      }

      .el-table__body {
        td.el-table__cell {
          line-height: 40px;
        }
      }
    }

    .data-tip {
      display: flex;
      align-items: center;
      background-color: #e0ebff;
      padding: 16px 24px 16px 24px;
      margin-bottom: 16px;
      border-radius: 6px;
      font-size: 12px;
      line-height: 22px;
      color: rgba(0, 0, 0, 0.9);

      .msg {
        margin-left: 5px;
      }

      .grow {
        flex-grow: 1;
      }
    }

    .opera-bottom {
      display: flex;
      align-items: center;

      .info {
        font-size: 18px;
        line-height: 26px;
        color: #303133;

        span {
          font-size: 20px;
          color: red;
        }
      }

      .grow {
        flex-grow: 1;
      }
    }

    .pay-wrap-wrap {
      display: flex;
      align-items: center;
      padding: 10px 0 20px 0;

      .item {
        width: 0;
        cursor: pointer;
        flex-grow: 1;
        padding: 0 10px;
        box-sizing: border-box;
        display: flex;
        height: 80px;
        align-items: center;
        border: 1px solid #e3e3e3;
        box-shadow: 0 0 1px 2px rgba(0, 0, 0, .1);
        position: relative;

        .my-icon {
          width: 30px;
          height: 30px;
          background-color: #4285f4;
          border-radius: 50%;
        }

        > h5 {
          margin-left: 10px;
        }

        .active-icon {
          width: 37px;
          position: absolute;
          right: 0;
          top: 0;
          visibility: hidden;
        }

        &.active {
          border: 1px solid #4285f4 !important;
          background-color: #e0ebff;

          .active-icon {
            visibility: visible;
          }
        }
      }
    }
  }
}
</style>
